import { render, staticRenderFns } from "./WritingSkill.vue?vue&type=template&id=30267e71&scoped=true"
import script from "./WritingSkill.vue?vue&type=script&lang=js"
export * from "./WritingSkill.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "30267e71",
  null
  
)

export default component.exports